export default __webpack_public_path__ + "6a771fc4163cc9b20f7bd1d64c884639.png";